/**
 * @file   src\components\CWInput.tsx
 * @brief  Input with label component.
 * @date   Jun, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { InputProperty } from '../interfaces/generalInterface';
import { forwardRef, Ref } from 'react';
import "../components/CWInput.scss";

const CWInput = forwardRef<HTMLInputElement, InputProperty>(({
  onChange,
  onBlur,
  onFocus,
  onKeyPress,
  onCopy,
  onPaste,
  onCut,
  label,
  isMandatory,
  autoFocus,
  autoComplete,
  errorMessage,
  value,
  id,
  name,
  type,
  accept,
  pattern,
  placeholder,
  disabled,
  maxLength,
  step,
  readOnly,
  labelSuffix
}, ref) => {

  return (
    <div className="form-group cw-input">
      <div className="cust-label-group">
        <label htmlFor="label">
          {label}
          {labelSuffix ? <span className="label-suffix">{labelSuffix}</span> : ''}
          {isMandatory && <span className="mandatory">*</span>}
        </label >
        <input
          className={errorMessage && errorMessage !== '' ? 'form-control error' : value !== '' ? 'form-control active' : 'form-control'}
          id={id}
          autoFocus={autoFocus}
          name={name}
          type={type}
          accept={accept}
          value={value}
          pattern={pattern}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
          onChange={(event) => onChange && onChange(event)}
          onBlur={(event) => onBlur && onBlur(event)}
          step={step}
          onFocus={(event) => onFocus && onFocus(event)}
          onKeyDown={(event) => onKeyPress && onKeyPress(event)}
          readOnly={readOnly}
          ref={ref}
          autoComplete={autoComplete}
          onCopy={onCopy}
          onPaste={onPaste}
          onCut={onCut}
        />
      </div >
      {errorMessage && errorMessage !== '' && <span className="error-msg">{errorMessage}</span>}
    </div >
  );
});

export default CWInput;
